import ServerDropdown_vue_vue_type_script_setup_true_lang_default from "./ServerDropdown.vue_vue_type_script_setup_true_lang.js";
//#region src/v2/components/server/ServerDropdown.vue
var ServerDropdown_default = ServerDropdown_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ServerDropdown_default as default };

//# sourceMappingURL=ServerDropdown.vue.js.map